// NewIdentityCard.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { CancelButton } from './CancelButton';
import Arrow‌BackWardIcon from '@mui/icons-material/ArrowCircleRight';
import { useNavigate } from 'react-router-dom';
interface WithOutStoper {
  contentMessage: string;
  /**
   * Pages that render a Breadcrumb pass false: the trail already covers going
   * back, and a second control for it is the duplication we are removing.
   */
  showBackButton?: boolean;
}
const WithOutStoper: React.FC<WithOutStoper> = ({
  contentMessage,
  showBackButton = true,
}) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: '400px',
        height: '60px',

        backgroundColor: 'white',
        borderRadius: 1,
        border: '1px solid #E5E5E8',
        display: 'inline-flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        align: 'center',
        gap: 10.5,
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          color: '#35373C',
          fontSize: 14,
          fontFamily: 'IRANYekanXFaNum',
          fontWeight: 700,
          lineHeight: '16px',
          wordWrap: 'break-word',
          justifyContent: 'space-between',
          paddingRight: 16,
        }}
      >
        {contentMessage}
      </Typography>

      {showBackButton && (
        <Typography
          sx={{
            textAlign: 'center',
            color: '#35373C',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            lineHeight: '16px',
            wordWrap: 'break-word',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '16px',
            paddingRight: '16px',
          }}
        >
          <CancelButton onClick={() => navigate('/identities')}>
            {'بازگشت به هویت‌ها'}
            <Arrow‌BackWardIcon />
          </CancelButton>
        </Typography>
      )}
    </Box>
  );
};

export default WithOutStoper;
